import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryChangeChargeList(requestBody) {
  return request({
    url: URL.act.changeCharge.queryChangeChargeListUrl,
    method: 'post',
    data: requestBody
  })
}

export function createChangeCharge(requestBody) {
  return request({
    url: URL.act.changeCharge.createChangeChargeUrl,
    method: 'post',
    data: requestBody
  })
}
export function batchCreateChangeCharge(requestBody) {
  return request({
    url: URL.act.changeCharge.batchCreateChangeChargeUrl,
    method: 'post',
    data: requestBody
  })
}

export function getChangeCharge(requestBody) {
  return request({
    url: URL.act.changeCharge.getChangeChargeUrl,
    method: 'post',
    data: requestBody
  })
}

export function updateChangeChargeState(requestBody) {
  return request({
    url: URL.act.changeCharge.updateChangeChargeStateUrl,
    method: 'post',
    data: requestBody
  })
}
// 查询指定业务的更改费用中的费用列表
export function queryJobChangingChargeList(params) {
  return request({
    url: URL.act.changeCharge.queryJobChangingChargeList,
    method: 'get',
    params
  })
}

export function queryChangingChargeList(requestBody) {
  return request({
    url: URL.act.changeCharge.queryChangingChargeList,
    method: 'post',
    data: requestBody
  })
}

